// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const LogOutIcon = /* @__PURE__ */ createIcon(
  'log-out',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M2 16.2V7.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C6.298 1.999 6.976 2 7.8 2H9a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C4 6.361 4 6.942 4 7.8v8.4c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C6.361 20 6.942 20 7.8 20H9a1 1 0 1 1 0 2H7.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.079-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C1.999 17.702 2 17.024 2 16.2m13.293-9.907a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 1 1-1.414-1.414L18.586 13H9a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414',
      },
    ],
  ]
);
